import { isMobileBrowser } from '../../../base/environment/utils';
import { getBrandingColorPalette } from '../../../base/styles';

/**
 * Injects dynamic styles for the Conference page based on interfaceConfig.
 *
 * @param {Object} interfaceConfig - The interface configuration object.
 * @param {boolean} isMobileBrowser - Whether the current browser is a mobile browser.
 */
export function injectConferenceStyles(interfaceConfig) {
    const backgroundColor = getBrandingColorPalette(interfaceConfig)?.background;
    const primaryColor = getBrandingColorPalette(interfaceConfig)?.primary;
    const secondaryColor = getBrandingColorPalette(interfaceConfig)?.secondary;
    const accent1 = `${getBrandingColorPalette(interfaceConfig)?.accent1}`;
    const accent2 = getBrandingColorPalette(interfaceConfig)?.accent2;
    const accent4 = getBrandingColorPalette(interfaceConfig)?.primary;

    if (isMobileBrowser()) {
        const style = document.createElement('style');

        style.innerHTML = `
                .hangup-button, .toolbox-icon {
                    width: 40px !important;
                    height: 40px !important;
                }
            `;
    }


    if (interfaceConfig.applyMeetingSettings) {
        const style = document.createElement('style');

        // this.props.dispatch(setParticipantColor(this.props._participant.id, tileBackground));
        style.innerHTML = `
                .toolbox-icon.toggled, #modal-dialog-ok-button, .css-1yhoyhh-arrowContainer, .css-17gbq7t-button-primary-small-button {
                background: ${primaryColor} !important;

                border: 1px solid ${accent1} !important;
                }
                .toolbox-icon {
                background: ${accent1} !important;
                }
                .reactions-menu {
                background: ${primaryColor} !important;
                }

                .hangup-button, #modal-dialog-cancel-button, .css-d4npnn-button-destructive-medium-fullWidth-topMargin {
                background: ${accent2} !important;
                }
                .settings-button-container {
                background: ${accent1} !important;
                border: 1px solid ${accent1} !important;
                }
                .prejoin #preview .settings-button-child .toolbox-icon {
                background: ${accent1} !important;
                }
                .participants_pane-content .jkdsjM, .participants_pane-content .VCWAZ, .css-1ijvpkf-button-secondary-medium-fullWidth-button, .chat-header {
                background: ${primaryColor} !important;
                border: none !important;
                }
                .participants_invite svg path, .invite-button-text {
                fill: ${primaryColor} !important;
                color: ${primaryColor} !important
                }
                .participants_invite svg path:hover, .participants_invite:hover .invite-button-text {
                fill: ${accent1} !important;
                color: ${accent1} !important
                }
                .participant-action-ellipsis-breakoutroom:hover {
                background: ${primaryColor} !important;
                }
                .css-1ijvpkf-button-secondary-medium-fullWidth-button span, .css-1ijvpkf-button-secondary-medium-fullWidth-button svg path {
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }
                .chat-panel, .participants_pane-content>:first-child, .participants_pane-content>:last-child {
                border: none !important;
                }
                .participants_pane-content .kFnuRv .sc-kkGfuU {
                background: none !important;
                }
                .hangup-settings-popup .audio-preview-content svg path, .hangup-settings-popup .audio-preview-content p {
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }

                button.sc-kEYyzF.emJtCb.sc-jTzLTM.kELpTo {
                background: ${accent2} !important;
                }
                button.sc-kEYyzF.emJtCb.sc-jTzLTM.iLRPyG {
                background: ${accent1} !important;
                }
                #knocking-participant-list button.primary, #knocking-participant-list .title {
                background: ${accent1} !important;
                color: ${primaryColor} !important;
                }
                .breakout-room-container {
                background: ${backgroundColor} !important;
                }
                .moderator-icon-participants, .participantpane-item-icons {
                background: ${primaryColor} !important;
                }
                .moderator-icon-participants svg path, .participantpane-item-icons svg path {
                fill: ${accent1} !important;
                }
                .toolbox-icon .invite-button svg path {
                fill: ${primaryColor} !important;
                }
                .largevideo-display-name {
                background: ${primaryColor} !important;
                color: ${accent1} !important
                }
                .meethour-switch input:checked+.meethour-switch-slider {
                background: ${primaryColor} !important;
                }
                .largevideo-display-name-info {
                background: ${accent1} !important;
                color: ${primaryColor} !important
                }
                .largevideo-display-name svg path {
                fill: ${accent1} !important
                }
                .react-button {
                background: ${primaryColor} !important;
                color: ${accent1} !important;
                }
                .smallIcon .meethour-icon {
                background: ${primaryColor} !important;
                }
                .language-selector-trigger-container span {
                color: ${primaryColor} !important;
                }
                .smallIcon .meethour-icon svg path {
                fill: ${accent1} !important;
                }
                .overflow-menu-item-text, .overflow-menu-item span, .overflow-menu-item {
                color: ${primaryColor} !important;
                }
                .attach-file svg path {
                fill: none !important;
                stroke: ${accent1} !important;
                }
                .video-quality-dialog-label-container.active {
                color: ${secondaryColor} !important;
                }
                .indicator-icon-container.indicator {
                background: ${accent1} !important;
                }
                .video-quality-dialog-label-container.active svg path, .video-quality-dialog-label-container.active span{
                fill: ${secondaryColor} !important;
                color: ${secondaryColor} !important;
                }
                .toolbox-icon svg path {
                fill: ${primaryColor} !important;
                }
                .toolbox-icon svg path :hover {
                fill: ${accent1} !important;
                }
                .videocontainer__toolbar .indicator-container svg path {
                fill: ${primaryColor} !important;
                }
                .settings-button-container .toolbox-icon.toggled svg path, .toolbox-icon.toggled svg path {
                fill: ${accent1} !important;
                }
                .header-dropdown {
                background: ${accent4} !important;
                }
                .header-dropdown .header-menu-item .header-menu-item-content svg, .header-dropdown .header-menu-item .header-menu-item-content svg g g path {
                fill: ${primaryColor} !important;
                }
                 .audio-output-preview button {
                background: ${primaryColor} !important;
                }
                 .audio-output-preview button span, .device-selection-column  button svg path {
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }
                .video-preview-label-text, .video-preview-label-text p {
                background: ${primaryColor} !important;
                color: ${accent1} !important;
                }
                .video_space_view_strip .video_space-icon svg path, .video_space_view_strip p {
                fill: ${primaryColor} !important;
                color: ${primaryColor} !important;
                }
                .menu-on .video_space-icon svg path {
                fill: ${primaryColor} !important;
                }
                .video_space-view_strip-menu .selected p, .video_space-view_strip-menu button svg path, .video_space-view_strip p{
                color: ${primaryColor} !important;
                fill: ${primaryColor} !important;
                }
                .video_space-view_strip p {
                color: ${primaryColor} !important;
                fill: ${primaryColor} !important;
                }
                .video_space-view_strip .video_space-icon svg path {
                fill: ${primaryColor} !important;
                }
                .video_space-view_strip-menu button:hover, .video_space-view_strip-menu button:hover svg path {
                background: ${secondaryColor} !important;
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }
                .video_space-view_strip-menu .selected svg path {
                fill: ${accent1} !important;
                }
                .audio-preview-content {
                background: ${primaryColor} !important;
                }
                .branded .notification-enter-done span {
                color: ${accent1} !important;
                }
                .picture-in-picture-icon svg {
                fill: transparent !important;
                stroke: ${accent1} !important;
                }
                .audio-preview-entry audio-preview-entry--selected {
                background: ${primaryColor} !important;
                }
                .audio-preview-header, p.audio-preview-entry-text, .audio-preview-header-icon svg path, .audio-preview-entry-text {
                color: ${accent1};
                fill: ${accent1} !important;
                }
                .audio-preview-speaker:hover .audio-preview-entry-text,.audio-preview-speaker:hover, .audio-preview-microphone:hover .audio-preview-entry-text {
                color: ${primaryColor} !important;
                }
                .audio-preview-microphone:hover .audio-preview-entry, .audio-preview-speaker:hover .audio-preview-entry {
                background: ${accent1} !important;
                color: ${primaryColor} !important;
                }
                p.audio-preview-entry-text--selected {
                color: ${primaryColor} !important;
                }
                .audio-preview-entry--selected {
                color: ${primaryColor} !important;
                background: ${accent1} !important;
                }
                .css-1ae9ir7-button-tertiary-medium-fullWidth-autoAssignButton {
                background: ${primaryColor} !important;
                color: ${accent1} !important
                }
                .video_space-view_strip:hover .video_space-icon svg path, .video_space-view_strip:hover p {
                fill: ${accent1} !important;
                color: ${accent1} !important;
                }
                .video-preview-container {
                background: ${primaryColor} !important;
                }
                .video_space-view_strip:hover {
                background: ${primaryColor} !important;
                border: 1px solid ${accent1} !important;
                }
                #modal-dialog-ok-button span {
                color: ${accent1} !important;
                } 
                #notifications-container .css-19hkyw {
                color: ${accent1} !important;
                }
                .participant_pane-header-icon svg path {
                fill: ${accent1} !important;
                }
                .close-dialog svg path {
                fill: ${accent1} !important;
                }
                #modal-dialog-cancel-button span {
                color: ${primaryColor} !important;
                }
                .date-head, .css-dy67z-button-secondary-medium-fullWidth span {
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }
                .chat-button svg path {
                fill: ${accent1};
                }
                .premeeting-screen .action-btn, .join-button-container svg path  {
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }
                .premeeting-screen .action-btn.meeth {
                background: ${primaryColor} !important;
                border: 1.5px solid ${accent1};
                }
                .conference-bottom-bar {
                background: ${primaryColor}ad !important;
                border: 1px solid ${secondaryColor}ad !important;
                }
                .conference-sidebar {
                background: ${primaryColor}ad !important;
                border: 1px solid ${secondaryColor}ad !important;
                }
                .filmstrip__videos .videocontainer.videoContainerFocused {
                outline: 4px solid ${secondaryColor} !important;
                }
                .active-speaker {
                outline: 4px solid ${primaryColor} !important;
                }
                .videocontainer__toolbar .indicator-container {
                background: ${accent1} !important;
                border-radius: 50% !important;
                }
                .settings-button-container .toolbox-icon  svg path {
                fill: ${accent1} !important
                }
                .continue-browser a:hover {
                color: ${secondaryColor} !important;
                }
                .large-video-labels .circular-label {
                color: ${primaryColor} !important;
                }
                .IconWarningButtonParent .toolbox-icon.toggled svg path {
                fill: ${accent1} !important;
                }
                .large-video-labels .circular-label :hover {
                color: white !important;
                }
                .settings-button-container .language-selector-trigger-container svg path, .settings-button-container .language-selector-trigger-container span {
                fill: ${primaryColor} !important;
                color: ${primaryColor} !important;
                }
                .settings-button-container .language-selector-trigger-container:hover svg path, .settings-button-container .language-selector-trigger-container:hover span {
                fill: ${accent1} !important;
                color: ${accent1} !important;
                }
                .header-count-badge, .badge-round {
                background: ${secondaryColor} !important;
                color: ${primaryColor} !important;
                }
                .badge-round span {
                color: ${accent1} !important;
                }
                .pipstroke svg path, .pipstroke svg rect{
                stroke: ${primaryColor} !important;
                fill: ${accent1} !important;
                }
                .pipstroke:hover svg rect {
                fill: ${primaryColor} !important;
                stroke: ${accent1} !important;
                }
                .speakerstats {
                background: ${accent2} !important;
                }
                .speakerstats span {
                color: ${primaryColor} !important;
                }
                .pipstroke:hover svg path {
                stroke: ${accent1} !important;
                }
                .toolbox-icon:hover, .toolbox-icon .toggled, overflow-btn-pre-meeting-toolbox {
                background: ${primaryColor} !important;
                border: 1px solid ${accent1} !important;
                }
                .breakout-room-container .breakout-rooms-action-ellipsis {
                background: ${primaryColor} !important;
                }
                .toolbox-icon:hover svg path, .toolbox-icon .toggled svg path {
                fill: ${accent1} !important;
                }
                .participants_page_heading {
                color: ${accent1} !important;
                }
                .displayNameContainer .displayname {
                background: ${primaryColor} !important;
                color: ${accent1} !important;
                }
                .chat-header h1, .chat-header svg path, .participants_pane-content .sc-kkGfuU svg path, participants_pane-content .sc-kkGfuU p {
                color: ${accent1} !important;
                fill: ${accent1};
                }
                .displayNameContainer .displayname-info {
                color: ${primaryColor} !important;
                background: ${accent1} !important;
                }
                .displayNameContainer .displayname svg path {
                fill: ${accent1} !important
                }
                .settings-button-container .toolbox-icon {
                background: ${primaryColor} !important;
                }
                #dialog-heading-1 div{
                color: ${accent1} !important;
                }
                input#participants-search-input {
                box-shadow: 0 0 0 1px ${primaryColor} !important;
                }
                input#participants-search-input:focus {
                box-shadow: 0 0 0 2px ${secondaryColor} !important;
                }
                .remote-video-menu-trigger svg {
                background: ${accent1} !important;
                }
                .remote-video-menu-trigger svg path {
                fill: ${primaryColor} !important;
                }
                .chat-button {
                background: ${primaryColor} !important;
                }
                .css-krjp51 header {
                background: ${primaryColor} !important;
                }
                .pcivX {
                border: 2px solid ${primaryColor} !important;
                }
                .css-ea4b39-ButtonBase, .custom-modal-header {
                background: ${primaryColor} !important;
                }
                #custom-modal-title, #modal-dialog-ok-button {
                color: ${accent1} !important;
                }
                .label_buttons, .label_buttons-connection {
                background: ${accent1} !important;
                }
                .label_buttons:hover, .label_buttons-connection:hover {
                background: ${primaryColor} !important;
                color: ${accent1} !important;
                border: 1px solid ${accent1} !important;
                }
                .label_buttons:hover span, .actions button> span {
                background: ${primaryColor} !important;
                color: ${accent1} !important;
                }
                .settings-button-container svg path {
                fill: ${primaryColor} !important;
                }
                .settings-button-container .toolbox-icon.microphone-toolbox-button.is-speaking,
                .settings-button-container .toolbox-icon.is-speaking {
                --mic-speaking-green: ${secondaryColor || 'rgb(26, 204, 141)'} !important;
                }
                .settings-button-container .toolbox-icon.microphone-toolbox-button.is-speaking svg path,
                .settings-button-container .toolbox-icon.is-speaking svg path {
                fill: #ffffff !important;
                }
                .label_buttons:hover p, #knocking-participant-list ul li .details, span.css-g66oxm, span.sc-bwzfXH.dumDwk {
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }
                .language-button-container:hover .language-selector-trigger-container span {
                color: ${accent1} !important;
                }
                .meeting-name, .subject-conference-timer, .css-1kp15g5-formControl {
                color: ${accent1} !important;
                }
                .header_conference_group_1 span {
                background: ${accent1} !important;
                }
                .video_space_view_strip-menu button:hover {
                background: ${accent1} !important;
                }
                .video_space_view_strip-menu button:hover p, .video_space_view_strip-menu button:hover svg path {
                color: ${primaryColor} !important;
                fill: ${primaryColor} !important;
                }
                .pin_private_button svg path {
                stroke: ${primaryColor} !important;
                }
                .header-menu-item, .header-submenu-item {
                background: ${accent1} !important;
                color: ${primaryColor} !important;
                margin: 5px;
                width: 95%;
                border-radius: 10px;
                }
                .header-submenu {
                background: ${primaryColor} !important;
                }
                .prejoin-preview-status--ok {
                background: ${secondaryColor} !important;
                }
                .video_space_view_strip-menu button svg path, .video_space_view_strip-menu p {
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }
                .copy-meeting .url {
                background: ${primaryColor} !important;
                }
                .meeting-link-desktop .copy-meeting .url .done {
                background: ${primaryColor}  !important;
                }
                .copy-meeting .url .copy-meeting-icon {
                background: ${secondaryColor} !important;
                }
                .copy-meeting .url  .copy-meeting-icon .done {
                background: ${secondaryColor} !important;
                fill: ${secondaryColor} !important;
                }
                .copy-meeting-icon p, .copy-meeting-icon svg path {
                color: ${primaryColor} !important;
                fill: ${primaryColor} !important;
                }
                .copy-meeting-text {
                color: ${accent1} !important;
                }
                .invite-more-dialog-conference-url {
                background: ${secondaryColor} !important;
                }
                .copy-button-content {
                color: ${accent1} !important;
                }
                .label_buttons svg path, .label_buttons p, .label_buttons svg g, .label_buttons svg circle, .label_buttons span {
                fill: ${primaryColor} !important;
                color: ${primaryColor} !important;
                }
                #conference-timer-countdown p {
                background: ${accent2} !important;
                }
                .indicatoricon svg path {
                fill: ${primaryColor} !important;
                stroke: ${primaryColor} !important;
                }
                .participants_pane-content>:first-child {
                background: ${primaryColor} !important;
                }
                button.iconButton div>svg {
                    fill: ${accent1} !important;
                }
                .meeting-participant-context-menu {
                background: ${primaryColor} !important;
                }
                .remotevideomenu svg {
                background: ${accent1} !important;
                }
                .remotevideomenu svg path {
                fill: ${primaryColor} !important;
                }
                .label_buttons:hover svg path {
                fill: ${accent1} !important;
                }
                span.remotevideomenu:hover ul.popupmenu, ul.popupmenu:hover, ul.popupmenu {
                background: ${primaryColor} !important;
                }
                .popupmenu__item {
                background: ${secondaryColor} !important;
                }
                .settings-button-container:hover, .overflow-btn-pre-meeting-toolbox:hover {
                background: ${primaryColor} !important;
                border: 1px solid ${accent1} !important;
                }
                .settings-button-container:hover svg path {
                fill: ${accent1} !important;
                }
                .header_conference_view_icon svg path {
                fill: ${accent1} !important;
                }
                .overflow-btn-pre-meeting-toolbox {
                background: ${accent1} !important;
                }
                .overflow-btn-pre-meeting-toolbox svg path, .prejoin #preview .settings-button-child .toolbox-icon svg path {
                fill: ${primaryColor} !important;
                }
                .overflow-btn-pre-meeting-toolbox:hover svg path {
                fill: ${accent1} !important;
                }
                .overflow-menu-item {
                background: ${accent1} !important;
                }
                .header_conference_group_1 #conference-timer .subject-conference-timer {
                background: unset !important;
                }
                .header_conference_group_2 #conference-timer-countdown .subject-conference-timer {
                background: ${accent1} !important;
                color: ${primaryColor} !important;
                }
                .overflow-menu-item:hover {
                background: ${secondaryColor} !important;
                }
                .headerFooter, .footer-container, .pre-join-container, .iconButton .breakout-rooms-action-ellipsis {
                background: ${primaryColor} !important;
                }
                .breakout-rooms-action-ellipsis:hover {
                background: ${primaryColor} !important;
                }
                .full-screen-header-icon svg path, .largevideo-full-screen svg path {
                fill: none !important;
                }
                .full-screen-header-icon svg g g path, .largevideo-full-screen svg g g path, .exit-full-screen svg path, .largevideo-exit-full-screen svg path {
                fill: ${primaryColor} !important;
                }
                .full-screen-header-icon:hover svg path {
                fill: none !important;
                }
                .header_conference_group_2 .exit-full-screen:hover svg path {
                fill: ${accent1} !important;
                }
                .full-screen-header-icon:hover svg g g path{
                fill: ${accent1} !important;
                }
                #localchat .usermessage, .css-dy67z-button-secondary-medium-fullWidth, .poll-button-primary, .css-kerl90-button-medium, .css-1leoogr-button-primary-medium-fullWidth {
                background: ${primaryColor} !important;
                color: ${accent1} !important;
                }
                #conference-timer-countdown .subject-conference-timer {
                background: ${accent2} !important;
                }
                .css-kerl90-button-medium span,  {
                color: ${accent1} !important;
                }
                .css-a5gg4h {
                background: ${primaryColor} !important;
                }
                .css-g66oxm, .css-vd317 svg path {
                color: ${accent1} !important;
                fill: ${accent1} !important;
                }
                .css-xu4x1c-Expander div  {
                color: ${accent1} !important
                }
                .video-preview-entry--selected {
                border: 3px solid ${secondaryColor} !important;
                }
            `;
        document.head.appendChild(style);
    }

}
